
















import {Component, Vue} from "vue-property-decorator";
import {login} from "@/services/api"
import store from "@/store";

@Component({
})
export default class Login extends Vue {
  // 登录表单
  public formData = {
    userName: '',
    password: ''
  }

  /**
   * 登录接口调用
   */
  login(): void {
    login(this.formData, true).then(res => {
      if (res.data && res.data.status === 'OK') {
        const authorityList: string[] = res.data.result.authorities.map((item: {authority: string}) => item.authority);
        store.commit('SET_AUTHORITY', authorityList);
        let defaultPath = '/page/list'
        // if (authorityList.indexOf('ROLE_投手') !== -1) {
        //   defaultPath = '/edit/list'
        // } else if (authorityList.indexOf('ROLE_审核') !== -1) {
        //   defaultPath = '/item/list'
        // }
        const redirect: any = this.$route.query.redirect || defaultPath;
        this.$router.replace(redirect);
      } else {
        this.$message.error(res.data.body.message);
      }
    }).catch(() => {})
  }

  /**
   * todo 表单检查
   */
  checkForm() {

  }
}

